import { SVGProps } from 'react';

const SvgCapsules = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M48 144c0-35.3 28.7-64 64-64s64 28.7 64 64v112H48V144zm-48 0v224c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8l128.5 187.3c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3c-35.5-51.8-105.4-64.3-156-28.1-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm283.4 73.3c-20.9-30.4-13.3-72.2 15.8-93 28.5-20.4 68-13.7 88.5 16.2l66.9 97.5-106.1 74.2-65.1-94.9z" />
  </svg>
);
export default SvgCapsules;
